// Copyright (c) 2016 Deere & Company

import './claim-value-summary.scss';
import React, {PropTypes} from 'react';
import {getCreditMemoFormName, getCreditMemoObjectId} from '../../../../shared/services/credit-memo-services';
import Accordion from '../../../../shared/components/accordion';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimValueDetails from '@deere/cps-it.warranty-model-factory/lib/claim-value-details';
import ClaimValueSummaryBody from './claim-value-summary';
import {FormattedMessage} from 'react-intl';
import ReimbursementDetails from '@deere/cps-it.warranty-model-factory/lib/claim-reimbursement-details';
import SmartFormLink from '../../../../shared/components/smart-form-link/smart-form-link';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildCurrency} from '../../../../shared/services/build-number';
import {hasCreditMemoAction} from '../../../../shared/services/allowed-actions-services';

const ClaimValueSummary = props => {

    const title = (
        <header>
            <FormattedMessage id='REIMBURSEMENT_DETAILS'/>
            <div className='total-amount'>
                {`${buildCurrency(props.reimbursementDetails.totalApproved)} ${props.claimValueDetails.currency.key}`}
            </div>
            <div className='recovery-percentage'>
                {props.reimbursementDetails.recoverPercentage >= 0 &&
                    <FormattedMessage
                        id='CLAIM_RECOVER_PERCENTAGE'
                        values={{
                            percentage: props.reimbursementDetails.recoverPercentage.toFixed(2)
                        }}
                    />
                }
            </div>
            {hasCreditMemoAction(props.allowedActions) &&
                <div className='credit-memo'>
                    <SmartFormLink
                        displayText='CREDIT_MEMO'
                        formName={getCreditMemoFormName(props.claimValueDetails.creditMemoNumber)}
                        objectId={getCreditMemoObjectId(props.claimValueDetails.creditMemoNumber, props.claimNumber)}
                        translate={true}
                    />
                </div>
            }
        </header>
    );

    const body = <ClaimValueSummaryBody claimValueDetails={props.claimValueDetails}/>;

    return props.reimbursementDetails.totalApproved ?
        <Accordion
            accordionId='claim-value-summary'
            body={body}
            title={title}
        /> :
        null;

};

ClaimValueSummary.displayName = 'ClaimValueSummary';
ClaimValueSummary.propTypes = {
    allowedActions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    claimNumber: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    claimValueDetails: PropTypes.instanceOf(ClaimValueDetails).isRequired,
    reimbursementDetails: PropTypes.instanceOf(ReimbursementDetails).isRequired
};
ClaimValueSummary.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default ClaimValueSummary;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value-summary/index.js